module.exports = __webpack_public_path__ + "static/img/logo66.934ec28.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo66.png
// module id = Hh41
// module chunks = 1